/* "Is this a gift?" NO/YES reveal. Added by Oleg @ IAKOE.
   UI-only: the message itself saves via the kit <ia-cart-note> JS (the .js-note-update
   button + [data-note-field="note"] textarea live inside this element). Here we just
   reveal/hide the message field and, on "No", clear it and persist the empty note. */
if (!customElements.get('ts-cart-gift')) {
  class TsCartGift extends HTMLElement {
    connectedCallback() {
      this.body = this.querySelector('.ts-cart-gift__body');
      this.message = this.querySelector('[data-note-field="note"]');
      this.saveBtn = this.querySelector('.js-note-update');
      this.noBtn = this.querySelector('[data-gift-no]');
      this.yesBtn = this.querySelector('[data-gift-yes]');

      this.noBtn?.addEventListener('click', () => this.setGift(false));
      this.yesBtn?.addEventListener('click', () => this.setGift(true));

      // No visible save button (per design) — persist the message on blur.
      this.message?.addEventListener('blur', () => this.saveBtn?.click());
    }

    setGift(on) {
      this.classList.toggle('is-gift', on);
      if (this.body) this.body.hidden = !on;
      this.noBtn?.setAttribute('aria-pressed', String(!on));
      this.yesBtn?.setAttribute('aria-pressed', String(on));

      if (on) {
        this.message?.focus();
      } else if (this.message && this.message.value) {
        // Turning the gift off clears the message and persists the empty note.
        this.message.value = '';
        this.saveBtn?.click();
      }
    }
  }
  customElements.define('ts-cart-gift', TsCartGift);
}
